import { BudgetResetTypeValues } from 'src/components/oneCorp/features/MealCredit/common/formFields/Select/BudgetResetTypeSelect/BudgetResetTypeSelect.utils';
import {
  MealCreditLength,
  MONTHLY_DEFAULT_BUDGET_RESET_PERIOD,
} from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';
import { IMealCredit } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseMealCreditsDetailsPage.utils';
import { DEFAULT_WEEK_LENGTH_DAYS } from 'src/models/LineOfCreditModelUtils';
import { MealCreditInstanceType } from 'src/types/LineOfCredit';

export interface GetBudgetPeriodProps {
  instanceType: IMealCredit['instance_type'];
  budgetResetPeriod: IMealCredit['budget_reset_period'];
}

export function getBudgetPeriod({
  instanceType,
  budgetResetPeriod,
}: GetBudgetPeriodProps): MealCreditLength | null {
  switch (instanceType) {
    case MealCreditInstanceType.DAILY:
      return MealCreditLength.DAILY;

    case MealCreditInstanceType.MONTHLY:
      return budgetResetPeriod > MONTHLY_DEFAULT_BUDGET_RESET_PERIOD
        ? MealCreditLength.CUSTOM
        : MealCreditLength.MONTHLY;

    case MealCreditInstanceType.WEEKLY:
      return budgetResetPeriod === DEFAULT_WEEK_LENGTH_DAYS
        ? MealCreditLength.WEEKLY
        : MealCreditLength.CUSTOM;

    default:
      return null;
  }
}

export const getFormattedBudgetResetPeriod = (
  instanceType: IMealCredit['instance_type'],
  budgetResetPeriod: IMealCredit['budget_reset_period']
): string => {
  if (instanceType === MealCreditInstanceType.MONTHLY) {
    return budgetResetPeriod.toString();
  }

  if (budgetResetPeriod % 7 === 0) {
    return (budgetResetPeriod / 7).toString();
  }
  return budgetResetPeriod.toString();
};

export const getBudgetResetType = (
  instanceType: IMealCredit['instance_type'],
  budgetResetPeriod: IMealCredit['budget_reset_period']
): BudgetResetTypeValues => {
  if (instanceType === MealCreditInstanceType.MONTHLY) {
    return BudgetResetTypeValues.MONTHS;
  }

  if (budgetResetPeriod % 7 === 0) {
    return BudgetResetTypeValues.WEEKS;
  }
  return BudgetResetTypeValues.DAYS;
};
